import angular from 'angular';
import template from './detalji.pacijenta.html';
import {DetaljiPacijentaController} from './detalji.pacijenta.controller.js';

const DetaljiPacijentaComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: DetaljiPacijentaController,
    controllerAs: 'vm'
};

export {DetaljiPacijentaComponent};



// WEBPACK FOOTER //
// ./app/components/pacijent/detalji.pacijenta.component.js